import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { defineCustomElements } from '@scania/tegel/loader';
import { environment } from './environments/environment';
import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { appConfig, MSALInstanceFactory } from './app/app.config';
import { PublicClientApplication } from '@azure/msal-browser';

const msalInstance = MSALInstanceFactory() as PublicClientApplication;

async function bootstrap() {
  defineCustomElements(window);
  if (environment.production) {
    enableProdMode();
  }

  await msalInstance.initialize();

  const response = await msalInstance.handleRedirectPromise();

  if (response?.account) {
    msalInstance.setActiveAccount(response.account);
  } else {
    const accounts = msalInstance.getAllAccounts();
    if (accounts.length > 0) {
      msalInstance.setActiveAccount(accounts[0]);
    }
  }
  bootstrapApplication(AppComponent, {
    ...appConfig,
    providers: [provideZoneChangeDetection(), ...appConfig.providers],
  }).catch((err) => console.error(err));
}

bootstrap();
